export const StarIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.86127 7.36335L8.73019 7.59849C8.58621 7.85677 8.51422 7.98591 8.40198 8.07112C8.28973 8.15633 8.14994 8.18796 7.87035 8.25122L7.61581 8.30881C6.63195 8.53142 6.14001 8.64273 6.02297 9.01909C5.90593 9.39546 6.2413 9.78763 6.91204 10.572L7.08557 10.7749C7.27617 10.9978 7.37147 11.1092 7.41435 11.2471C7.45722 11.385 7.44281 11.5336 7.41399 11.831L7.38776 12.1018C7.28635 13.1482 7.23565 13.6715 7.54206 13.9041C7.84847 14.1367 8.30907 13.9246 9.23026 13.5005L9.46859 13.3907C9.73037 13.2702 9.86126 13.2099 10 13.2099C10.1387 13.2099 10.2696 13.2702 10.5314 13.3907L10.7697 13.5005C11.6909 13.9246 12.1515 14.1367 12.4579 13.9041C12.7644 13.6715 12.7136 13.1482 12.6122 12.1018L12.586 11.831C12.5572 11.5336 12.5428 11.385 12.5857 11.2471C12.6285 11.1092 12.7238 10.9978 12.9144 10.7749L13.088 10.572C13.7587 9.78763 14.0941 9.39546 13.977 9.01909C13.86 8.64273 13.3681 8.53142 12.3842 8.30881L12.1296 8.25122C11.8501 8.18796 11.7103 8.15633 11.598 8.07112C11.4858 7.98592 11.4138 7.85678 11.2698 7.5985L11.1387 7.36335C10.6321 6.45445 10.3787 6 10 6C9.62126 6 9.36792 6.45446 8.86127 7.36335Z"
        fill="#FFB800"
      />
    </svg>
  )
}
